import React from 'react';
import SEO from '../components/SEO';
import PageHero from '../components/PageHero';
import LegalLayout from '../components/LegalLayout';

const DataDeletion: React.FC = () => {
  return (
    <div>
      <SEO
        title="Data Deletion Instructions"
        description="Step-by-step instructions for requesting deletion of your data from eTENANT, including accounts created with Facebook Login."
        path="/data-deletion"
        breadcrumb="Data Deletion Instructions"
      />

      {/* Page Header */}
      <PageHero
        crumb="Data Deletion"
        title={<>eTENANT - Data Deletion Request</>}
        subtitle="Property Management App for Android"
      />

      {/* Data Deletion Content */}
      <LegalLayout>

        <div className="deletion-section mb-5">
          <h2 className="section-title mb-3">Request Data Deletion</h2>
          <p className="mb-3">
            You can request deletion of your eTENANT app data through two methods:
          </p>

          <h3 className="mb-3">Method 1: In-App Deletion (Recommended)</h3>
          <ol className="mb-4">
            <li>Open the eTENANT app on your device</li>
            <li>Go to Profile → Edit Profile</li>
            <li>Scroll to "Danger Zone" section</li>
            <li>Tap "Delete Account"</li>
            <li>Confirm deletion to permanently remove all data</li>
          </ol>

          <h3 className="mb-3">Method 2: Email Request</h3>
          <p className="mb-3">
            Send an email to: <strong><a href="mailto:support@etenant.net" className="text-primary">support@etenant.net</a></strong>
          </p>
          <p className="mb-3">Include: Your registered email address and specific deletion request</p>
          <p>Response time: Within 30 days</p>
        </div>

        <div className="deletion-section mb-5">
          <h2 className="section-title mb-3">Data Types Deleted</h2>
          <p className="mb-3">
            When you delete your eTENANT account, the following data is permanently removed:
          </p>
          <ul className="mb-3">
            <li><strong>All Properties</strong> - Property listings, photos, details</li>
            <li><strong>All Tenants</strong> - Tenant information and contact details</li>
            <li><strong>All Rental Agreements</strong> - Contract data and terms</li>
            <li><strong>All Payments</strong> - Payment history and records</li>
            <li><strong>All Maintenance Requests</strong> - Service requests and status</li>
            <li><strong>All Notifications</strong> - Push notifications and alerts</li>
            <li><strong>User Profile</strong> - Name, email, phone, account data</li>
            <li><strong>Subscription Data</strong> - Billing history and active subscriptions</li>
          </ul>
        </div>

        <div className="deletion-section mb-5 legal-v2-callout legal-v2-callout-warning">
          <h2 className="section-title mb-3">⚠️ Important Notice</h2>
          <p className="mb-3">
            <strong>Data deletion is permanent and cannot be undone.</strong>
          </p>
          <p className="mb-3">
            <strong>Retention Period:</strong> No data is retained after deletion request is processed.
          </p>
          <p>
            <strong>Processing Time:</strong> Deletion is immediate for in-app requests, up to 30 days for email requests.
          </p>
        </div>

        <div className="deletion-section mb-5">
          <h2 className="section-title mb-3">Contact Information</h2>
          <p className="mb-3">For questions about data deletion or privacy:</p>
          <p className="mb-3">
            Email: <strong><a href="mailto:support@etenant.net" className="text-primary">support@etenant.net</a></strong>
          </p>
          <p className="mb-3">App: eTENANT Property Management</p>
          <p>Developer: eTENANT</p>
        </div>

        <p><small>Last updated: September 2024</small></p>

      </LegalLayout>
    </div>
  );
};

export default DataDeletion;